import { createSlice } from '@reduxjs/toolkit';

import { type AdminPortalFaqItem } from './services';
import {
  createPortalFaq,
  deletePortalFaq,
  listPortalFaqs,
  reorderPortalFaqs,
  updatePortalFaq,
} from './actions';

interface PortalFaqState {
  items: AdminPortalFaqItem[];
  loading: boolean;
  error: string | null;
}

const initialState: PortalFaqState = {
  items: [],
  loading: false,
  error: null,
};

const portalFaqSlice = createSlice({
  name: 'portalFaq',
  initialState,
  reducers: {
    clearPortalFaqError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listPortalFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listPortalFaqs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(listPortalFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar FAQs';
      })
      .addCase(createPortalFaq.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updatePortalFaq.fulfilled, (state, action) => {
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(deletePortalFaq.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
      })
      .addCase(reorderPortalFaqs.fulfilled, (state, action) => {
        const orderedIds = action.payload;
        const itemMap = new Map(state.items.map((item) => [item.id, item]));
        state.items = orderedIds
          .map((id) => itemMap.get(id))
          .filter((item): item is AdminPortalFaqItem => item !== undefined);
      });
  },
});

export const { clearPortalFaqError } = portalFaqSlice.actions;
export default portalFaqSlice.reducer;
